import { createSlice } from '@reduxjs/toolkit';

const globalPopupsSlice = createSlice({
  name: 'globalPopups',
  initialState: {
    current: null,
    comparisonCommonPopup: {
      isShow: false,
      isSuccess: false,
      message: '',
      isBottom: false,
    },
    // for checkout and payment related snackbar info
    checkoutPopup: {
      isShow: false,
      isSuccess: false,
      message: '',
    },
  },
  reducers: {
    setGlobalPopup: (state, action) => ({
      ...state,
      current: action.payload,
    }),
    updateComparisonCommonPopupState: (state, action) => {
      const { isSuccess, message, isShow, isBottom } = action.payload;
      return {
        ...state,
        comparisonCommonPopup: {
          ...state.comparisonCommonPopup,
          isSuccess,
          message,
          isShow,
          isBottom,
        },
      };
    },
    updateCheckoutPopupState: (state, action) => {
      const { isShow, isSuccess, message } = action.payload;
      return {
        ...state,
        checkoutPopup: {
          ...state.checkoutPopup,
          isShow,
          isSuccess,
          message,
        },
      };
    },
    reset: (state) => ({
      ...state,
      current: null,
    }),
  },
});

export const {
  reset,
  setGlobalPopup,
  updateComparisonCommonPopupState,
  updateCheckoutPopupState,
} = globalPopupsSlice.actions;

export default globalPopupsSlice.reducer;
